module.exports = __webpack_public_path__ + "img/2_66.811177f6.png";